if (!customElements.get('spa-video-gallery')) {
    class SpaVideoGallery extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.selectors = {
                sliderWrapper: '.spa-video-gallery__wrapper',
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };

            this.classes = {
                grid: 'spa-video-gallery__grid',
                swiper: 'swiper',
                swiperWrapper: 'swiper-wrapper',
                slide: 'swiper-slide'
            };

            this.sectionId = this.dataset.sectionId;
            this.enableDesktopSlider = this.dataset.enableSlider === 'true';

            // Read configuration from data attributes (matching featured-collection pattern)
            this.items = parseInt(this.dataset.items || 4);
            this.tabletItems = parseInt(this.dataset.tabletItems || 3);
            this.laptopItems = parseInt(this.dataset.laptopItems || 4);

            this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

            // Select all items and add swiper-slide class initially if they don't have it
            const items = this.querySelectorAll('.spa-video-gallery__item');
            items.forEach(item => item.classList.add(this.classes.slide));

            this.sliderInstance = false;

            // Use the theme's configured breakpoint or fallback
            const mediaQuery = window.FoxTheme?.config?.mediaQueryMobile || '(max-width: 767px)';
            const mql = window.matchMedia(mediaQuery);

            // Handle resize/breakpoint changes
            mql.onchange = this.handleBreakpointChange.bind(this);

            // Initial check
            this.handleBreakpointChange(mql);
        }

        handleBreakpointChange(mql) {
            const isMobile = mql.matches;

            // Global check: if slider is enabled, we init it (responsive params handled in initSlider)
            // If disabled, we destroy it and fall back to CSS grid
            if (this.enableDesktopSlider) {
                this.initSlider(isMobile);
            } else {
                this.destroySlider();
            }
        }

        initSlider(isMobile) {
            if (typeof this.sliderInstance === 'object') return; // Already initialized
            if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

            // Switch classes
            this.classList.add(this.classes.swiper);
            this.sliderWrapper.classList.remove(this.classes.grid);
            this.sliderWrapper.classList.add(this.classes.swiperWrapper);

            // Ensure modules exist
            const modules = [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination];

            console.log('SPA Video Gallery Init (Refactored):', {
                items: this.items,
                tabletItems: this.tabletItems,
                laptopItems: this.laptopItems,
                enableSlider: this.enableDesktopSlider
            });

            const sliderOptions = {
                modules: modules,
                slidesPerView: 1.2, // Default mobile
                spaceBetween: 16,
                navigation: {
                    nextEl: this.querySelector(this.selectors.nextEl),
                    prevEl: this.querySelector(this.selectors.prevEl),
                },
                breakpoints: {
                    550: {
                        slidesPerView: 2.2,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: this.tabletItems,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: this.laptopItems,
                        spaceBetween: 20
                    },
                    1280: {
                        slidesPerView: this.items,
                        spaceBetween: 20
                    }
                }
            };

            this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
            this.sliderInstance.init();
        }

        destroySlider() {
            if (typeof this.sliderInstance !== 'object') return;

            this.sliderInstance.slider.destroy();
            this.sliderInstance = false;

            // Revert classes
            this.classList.remove(this.classes.swiper);
            this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
            this.sliderWrapper.classList.add(this.classes.grid);
        }
    }

    customElements.define('spa-video-gallery', SpaVideoGallery);
}
